import { executeOnce } from '../../../utils'

import { FileExtensionType } from '../..'
import { Usecase } from '../Usecase'

export abstract class CommissioningFileUsecase extends Usecase {
    readonly getSupportedServiceCommissioningFileExtensions = executeOnce(() =>
        this.configurationService.getSupportedFileExtensions(FileExtensionType.SERVICE_COMMISSIONING)
    )
}
